import React from 'react';

interface FieldProps {
    /** Id på formulärkontrollen som etiketten pekar på. */
    id: string;
    label: string;
    hint?: React.ReactNode;
    invalid?: boolean;
    optional?: boolean;
    children: React.ReactNode;
}

export default function Field({ id, label, hint, invalid = false, optional = false, children }: FieldProps) {
    const classes = ['breaks-field', invalid ? 'breaks-field--invalid' : ''].filter(Boolean).join(' ');
    return (
        <div className={classes}>
            <label className="breaks-field__label" htmlFor={id}>
                {label}
                {optional && <span className="breaks-field__optional"> (frivilligt)</span>}
            </label>
            {children}
            {hint && (
                <p className="breaks-field__hint" id={id + '-hint'} role={invalid ? 'alert' : undefined}>
                    {hint}
                </p>
            )}
        </div>
    );
}
